<style>
	.bg111 {
		background-color: #fff;width:100%; 
	}
 
 
.draw-enter-active, .draw-leave-active {
     transition: opacity 1s;
}
.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
     opacity: 0;
}
.top_area{width:100%;height:4vw;position:fixed;top:1vw;left:0; }
.top_area img{display:block;float:left;height:4vw; }
.tabbar3{width:84vw;height:4vw;background:url(../../assets/images/tabbar_bg.png) center center; border-radius:.5vw;
float:left;margin-left:2.5vw;background-size:105% 105%;  }
.tabbar3 span{display:block;float:left;line-height:4vw;font-size:1.4vw;}
.tabbar3 span.pos{  padding:0 1vw;}
.tabbar3 span.floder{ color:#666;}
 
.tabbar3 span.rights{background:url(../../assets/images/right.png) no-repeat;width:2vw;
height:4vw;background-position:center center;background-size:2vw;}
  
  
 
.submits_import{width:12vw;height:4vw;border:#c4c4c4 solid 1px;margin-top:5vw;border-radius:.5vw;cursor:pointer;}
.submits_import span{display:block;float:left;width:6vw;text-align:center;color:#c4c4c4;font-size:1.4vw;line-height:4vw;}
.submits_import img{display:block;float:left;width:2vw;margin-top:1vw;height:2vw;margin-left:1.5vw;}
.next_s{float:right;margin-right:35vw;background:#ddd;}
 
.next_s span{color:#fff;width:8vw;}
.next_s img{margin-left:0;}
.next_s:hover{background:#4C84FA; }



.pre_s{float:left;margin-left:35vw;background:#3268ff;color:#fff;}
.pre_s:hover{background:#4C84FA; }
.pre_s span{color:#fff;}

.template_divs{margin:0;padding:0;overflow:hidden;width:84vw; margin-left:7vw;margin-top:1vw;} 
.template_divs img.import_data{display:block;margin-top:12vw;width: 30vw}
.template_divs button{background:#ff9900;height:4.5vw;width:22vw;color:#fff;font-size:1.4vw;margin:0 auto;display:block;
border:0;outline:none;border-radius:.5vw;margin-top:2vw;}
.template_divs button:hover{background:#ff6600;}



.template_divs span.sm{display:block;margin:0 auto;width:100%;text-align:center;color:#3465ff;
	font-size:1.2vw;margin-top:2vw;text-decoration:underline;}
.template_divs span.sm:hover{color:#cc0000;cursor:pointer;}

.file_info{width:100%;height:3vw; margin-top:2vw;text-align:center;}
.file_info span.dt{color:#3465ff;font-size:1.1vw;text-decoration:underline;line-height:3vw;cursor:pointer;}
.file_info img.ex{width:2vw;vertical-align:middle;}
.file_info img.ch{width:1.5vw;vertical-align:middle;}



.mengban{width:100vw;height:100vh;position:fixed;top:0;z-index:999;
background:url(../../assets/images/yao_bg4.png) repeat;}
.progress22211{width:48vw;height:19vw;background:#fff;position:fixed;top:10vw;z-index:999999;left:26vw;border-radius:.5vw;overflow:hidden;}
.progress_hd222222{margin: 0;padding: 0;overflow: hidden;width:100%;height:4vw;font-size:1.5vw;font-weight:bold;border-bottom:#ddd solid 1px;color:#333;}

.progress_hd222222 span.ap{margin: 0;padding: 0;overflow: hidden;display:block;width:40%;margin-left:30%;float:left;line-height:4vw;text-align:center;}
.progress_hd222222 img{display: block;margin: 0;padding: 0;overflow: hidden;width: 2vw;margin-top: 1vw;float: right;margin-right: 2vw;}

 
.progress22211 p{display:block;width:90%;text-align:left;line-height:2.5vw;font-size:1.2vw;margin:0 auto;color:#333;margin-top:1vw;}
.progress22211 b{color: #c00;}
 
.progress22211 button{display: block;margin: 0 auto; height: 3.5vw;background: #3465ff;outline: none;color: #fff;border:#ccc solid 1px;border-radius: .5vw;font-size: 1.2vw;margin-top: 1vw;padding: 0 2vw;}


</style>
<template>
	<div class="bg111">
	     <u_center  ></u_center>
	     <div class="top_area">
		    <img @click="back()"  src="../../assets/images/home_icon.png">
			<div class="tabbar3">
			   <span class="pos">您的当前位置:</span>
			   <span class="floder">发送短信通知</span>
			   <span class="rights"></span>
			   <span class="floder">选择短信模板</span>
			   <span class="rights"></span>
			   <span class="floder">导入数据表</span>
			</div>
		 </div>
		  


         <transition name="draw">
		 <div class="mengban" v-show="des_show"></div>
		  </transition>
		 <transition name="draw">
		 <div class="progress22211" v-show="des_show">
				  <div class="progress_hd222222"><span class="ap">数据表规范说明</span><img  @click="close_des()" src="../../assets/images/cha.png"></div>
				  <p  >  										
1.每次导入数据表最多支持2000行，如果超过<b>2000行</b>请分多次发送。	</br>												
2.导入数据仅友好支持微软Excel<b>（.xls或.xlsx）</b>，若为WPS请转换为Excel格式。	</br>												
3.查看标准数据表格式，请点击下方按钮复制文件链接在浏览器打开。										
 </p>  
 <button @click="doCopy()">复制链接</button>
				  
		 </div>
         </transition>
   






		 <div class="template_divs">
		      <img src="../../assets/images/importing.png" class="import_data">
		      <button @click="choiceImg" v-if="!file_name">请导入数据表</button>
			  <div class="file_info" v-else>
			     <img class="ex" src="../../assets/images/excel.png">
			     <span class="dt">{{file_name}}</span>
				 <img class="ch" @click="del_file()" src="../../assets/images/cha.png">
			  </div>
			  <input ref="filElem" type="file" name="excel" id="excel" style="display:none;" v-on:change="upload">
			  <span class="sm" @click="open_des()">查看数据表规范说明</span>
		 </div>
		 
		 <div class="submits_import pre_s" @click="back()">
			  <img src="../../assets/images/pre.svg">
			 <span>返回</span> 
		 </div>
		  <div class="submits_import next_s" :style="bgcolor"  @click="nextstep()">
			 <span >继续</span> 
			 <img src="../../assets/images/next.svg">
		 </div>

	</div>
</template>
<script>
import u_center from '@/components/u_center.vue'; 
	export default {
	    components: {
		  u_center,
	    },
		data() {
			return {
				bgcolor:"background:#ddd;",
                file_enable:false,
				file:"",
				template:"",
				file_name:"",
				des_show:false,
				url:"https://www.scedu.tech/temp/datatemp.xlsx"
			}
		},
		mounted() {
		    let self=this;
		    this.template = this.$utils.getUrlKey('template');
			
		},
		methods: {
			doCopy: function () {
			         	let _this=this
						this.$copyText(this.url).then(function (e) {
						   _this.$toast.center("复制成功");
						  console.log(e)
						}, function (e) {
						   this.$toast.center("复制失败");
						  console.log(e)
						})
	       },
			close_des(){
                this.des_show=false;
			},
			open_des(){
                this.des_show=true;
			},
		    containSpecial( s )      
			{      
				var sss = RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]")
				
				return ( sss.test(s) );      
			}  ,
		     upload:function(file) {
			    this.file=file;
                var files2=this.$refs.filElem.files[0];
                var str=files2.name;				
				var ext1=str.substring(str.length - 3);
                var ext2=str.substring(str.length - 4);				
				if (ext1!='xls' && ext2!='xlsx') {
                    this.$toast.center('数据表只能是 xls、xlsx格式!')
                    return
                } 
				var flag = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]")
 
				if(ext1=='xls'){
				   var str=str.slice(0,str.length-4)
				   if(this.containSpecial(str)){
				      this.$toast.center('文件名不得包含特殊字符');
					  return;
				   }
				}
				if(ext2=='xlsx'){
				   var str=str.slice(0,str.length-5)
				   if(this.containSpecial(str)){
				      this.$toast.center('文件名不得包含特殊字符');
					  return;
				   }
				    
				}


				
				const extension = files2.name.split('.')[1] === 'xls'
                const extension2 = files2.name.split('.')[1] === 'xlsx'
                const isLt5M = files2.size / 1024 / 1024 < 5
                if (!extension && !extension2) {
                    this.$toast.center('数据表只能是 xls、xlsx格式!')
                    return
                }
                if (!isLt5M) {
                    this.$toast.center('数据表大小不能超过 5MB!')
                    return
                } 
				 
				// this.bgcolor='background:#3465ff;';
			    // this.file_enable=true;
				 this.uploadfiles();
            },nextstep(){
			    if(!this.file_enable){
				  this.$toast.center('请选择数据表文件')
				  return;
				}else{
				  if(this.template){
				    this.$router.push("/import_key?template="+this.template); 
				  }else{
				    this.$router.push("/import_key"); 
				  }
				  
				} 
			},
			uploadfiles(){
			    let self=this;
				var file=this.file;
                var forms = new FormData()
                var configs = {
                    headers:{'Content-Type':'multipart/form-data;charse=UTF-8'}
                };
				 console.log(file)
                forms.append('file',file.target.files[0]);
                axios.post(this.$api+'/message/uploads', forms,configs)
                    .then(function (response) {
					    let data=response.data;
                        if(data.state==1){    
                                localStorage.setItem("file",data.data.filename);	 
                                localStorage.setItem("name",data.data.name);

                                self.file_name=	data.data.name;							
					  			self.bgcolor='background:#3465ff;';
								self.file_enable=true;
				        }else{
						        self.$toast.center(data.msg);
								self.bgcolor='background:#ddd;';
								self.file_enable=false;
						}
                        file.target.value = '';
 
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
			},del_file(){
				  this.bgcolor='background:#ddd;';
				  this.file_enable=false;
				  this.file_name=false;		
			},
		    back(){
			  this.$router.go(-1)
			},choiceImg(){
              this.$refs.filElem.dispatchEvent(new MouseEvent('click'));
            },
		},watch:{
			 
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/sms/import_data.vue